import * as ActionTypes from '../ActionTypes';

const initialState = {
    exitReasonsLoading: false,
    exitReasonsData: [],
    clearanceTypeLoading: false,
    clearanceTypeData: [],
    error: null,
};

export const ECMSReducer = (state = initialState, action) => {
    switch (action.type) {
        case ActionTypes.GET_ECMS_EXIT_REASON_REQUEST:
            return {
                ...state,
                exitReasonsLoading: true,
                exitReasonsData: [],
                error: null,
            };

        case ActionTypes.ADD_ECMS_EXIT_REASON_REQUEST:
        case ActionTypes.UPDATE_ECMS_EXIT_REASON_REQUEST:
        case ActionTypes.DELETE_ECMS_EXIT_REASON_REQUEST:
            return {
                ...state,
                exitReasonsLoading: true,
                error: null,
            };

        case ActionTypes.GET_ECMS_EXIT_REASON_SUCCESS:
        case ActionTypes.ADD_ECMS_EXIT_REASON_SUCCESS:
        case ActionTypes.UPDATE_ECMS_EXIT_REASON_SUCCESS:
        case ActionTypes.DELETE_ECMS_EXIT_REASON_SUCCESS:
            return {
                ...state,
                exitReasonsLoading: false,
                exitReasonsData: action.payload?.data?.data,
                error: null,
            };

        case ActionTypes.GET_ECMS_EXIT_REASON_ERROR:
        case ActionTypes.ADD_ECMS_EXIT_REASON_ERROR:
        case ActionTypes.UPDATE_ECMS_EXIT_REASON_ERROR:
        case ActionTypes.DELETE_ECMS_EXIT_REASON_ERROR:
            return {
                ...state,
                exitReasonsLoading: false,
                error: true,
            };
        case ActionTypes.GET_ECMS_CLEARANCE_TYPE_REQUEST:
            return {
            ...state,
            clearanceTypeLoading: true,
            clearanceTypeData: [],
            error: null,
        };
        case ActionTypes.ADD_ECMS_CLEARANCE_TYPE_REQUEST:
        case ActionTypes.UPDATE_ECMS_CLEARANCE_TYPE_REQUEST:
        case ActionTypes.DELETE_ECMS_CLEARANCE_TYPE_REQUEST:
        return {
            ...state,
            clearanceTypeLoading: true,
            error: null,
        };

        case ActionTypes.GET_ECMS_CLEARANCE_TYPE_SUCCESS:
        case ActionTypes.ADD_ECMS_CLEARANCE_TYPE_SUCCESS:
        case ActionTypes.UPDATE_ECMS_CLEARANCE_TYPE_SUCCESS:
        case ActionTypes.DELETE_ECMS_CLEARANCE_TYPE_SUCCESS:
        return {
            ...state,
            clearanceTypeLoading: false,
            clearanceTypeData: action.payload?.data?.data || [],
            error: null,
        };

        case ActionTypes.GET_ECMS_CLEARANCE_TYPE_ERROR:
        case ActionTypes.ADD_ECMS_CLEARANCE_TYPE_ERROR:
        case ActionTypes.UPDATE_ECMS_CLEARANCE_TYPE_ERROR:
        case ActionTypes.DELETE_ECMS_CLEARANCE_TYPE_ERROR:
        return {
            ...state,
            clearanceTypeLoading: false,
            error: true,
        };
        default:
            return state;
    }
};
